import * as React from 'react';
import { FC, useEffect } from 'react';

import { useRoutesDisplayBottomService as useRoutesDisplayTopService } from 'components/top-service-mode/hooks/use-routes-display-top-service';
import { useHideTsmPointsNotificationLoyaltyBannerExperiment } from 'experiments/hide-tsm-pointsnotification-loyaltybanner/use-enable-item-detail-reorder-experiment';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { useCart } from 'hooks/use-cart';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useOrderContext } from 'state/order';
import { useStoreContext } from 'state/store';
import { routes } from 'utils/routing';

import { useTopServiceModeDetails } from './hooks/use-top-service-details';
import { TopServiceModeView } from './top-service-mode.view';
import { ITopServiceModeProps } from './types';

/**
 *
 * TopServiceMode purpose
 *
 */
const TopServiceMode: FC<React.PropsWithChildren<ITopServiceModeProps>> = () => {
  const enableOrdering = useFlag(LaunchDarklyFlag.ENABLE_ORDERING);
  const { resetStore, store } = useStoreContext();
  const topServiceModeDetails = useTopServiceModeDetails();
  const hideTsmOnHome = useHideTsmPointsNotificationLoyaltyBannerExperiment();
  const {
    CurbsideConfirmationModal,
    curbsideConfirmationModalOpen,
    setCurbsideConfirmationModalOpen,
  } = topServiceModeDetails;
  const showTopServiceOnRoutes = useRoutesDisplayTopService();
  const { setCurbsidePickupOrderId, setCurbsidePickupOrderTimePlaced } = useOrderContext();
  const { emptyCart } = useCart();

  const { navigate } = useNavigation();

  useEffect(() => {
    if (!enableOrdering) {
      resetStore();
    }
  }, [enableOrdering, store]);

  if (!showTopServiceOnRoutes || hideTsmOnHome) {
    return null;
  }

  const modalDismiss = () => setCurbsideConfirmationModalOpen(false);
  const cancelCurbsideOrder = () => {
    emptyCart();
    setCurbsidePickupOrderId('');
    setCurbsidePickupOrderTimePlaced('');
    modalDismiss();
    navigate(routes.storeLocator);
  };

  return (
    <>
      <TopServiceModeView {...topServiceModeDetails} />

      {curbsideConfirmationModalOpen && (
        <CurbsideConfirmationModal
          showDialog={curbsideConfirmationModalOpen}
          onKeepOrder={modalDismiss}
          onCancelOrder={cancelCurbsideOrder}
          onDismiss={modalDismiss}
        />
      )}
    </>
  );
};

export default TopServiceMode;
